export const NOTIFICATION_EXPORT_GENERIC_RETRY_MESSAGE = 'Tente novamente.';
